import { FC, useState } from 'react';

import { Button } from '@/components/button.tsx';
import SuccessModal from '@/components/Modals/SuccessModal';

import { startReminder } from '@/app/api';
import ErrorModal from '@/components/Modals/ErrorModal';

import { useAppDispatch } from '@/store/store';
import { removeClaimById } from '@/store/slices/claimsSlice';

interface IStartCell {
  id: number;
  debtorId: number;
}

const StartCell: FC<IStartCell> = ({ id, debtorId }) => {
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);

  const dispatch = useAppDispatch();

  const handleDelete = () => {
    dispatch(removeClaimById(id));
  };

  const handleStart = () => {
    setIsOpenSuccess(false);
    setIsOpenError(false);

    startReminder(debtorId)
      .then(() => setIsOpenSuccess(true))
      .catch(() => setIsOpenError(true));
  };

  return (
    <>
      <Button
        onClick={handleStart}
        className={
          'bg-[rgba(95,186,221,1)]  hover:bg-[rgba(31,43,64,1)] transition-[200ms] w-full max-w-[149px]'
        }>
        Start
      </Button>

      <SuccessModal
        isOpen={isOpenSuccess}
        setIsOpen={setIsOpenSuccess}
        action={handleDelete}
        title="Rykkerproces startet"
      />
      <ErrorModal isOpen={isOpenError} setIsOpen={setIsOpenError} />
    </>
  );
};

export default StartCell;
